import { Component, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilteredReport } from '../filtered-report';
import { WorkforceFilters } from '../filters/filters.component';
import { RiskData } from '../workforce.types';
import { WorkforceApiService } from '../workforce-api.service';

// UI feature flag: the risk forecast endpoint and rendering remain available for later use.
const SHOW_RISK_FORECAST = false;
interface ForecastRow { Department: string; 'Forecast Month': string; 'Predicted Risk Score': number | null; 'Predicted Risk Band': string | null; }

@Component({ selector: 'app-risk', standalone: false, templateUrl: './risk.component.html' })
export class RiskComponent extends FilteredReport<RiskData> implements OnDestroy {
  protected readonly endpoint = '/workforce/department-risk';
  protected readonly fallbackError = 'Unable to load risk scores.';
  readonly showRiskForecast = SHOW_RISK_FORECAST;
  private readonly forecastApi = inject(WorkforceApiService);
  private forecastSubscription?: Subscription;
  forecast: ForecastRow[] = [];
  forecastError = '';
  forecastLoading = false;
  get groupLabel(): string { return this.groupBy.charAt(0).toUpperCase() + this.groupBy.slice(1); }
  bandClass(band: string | null): string { return band === 'High' ? 'band-high' : band === 'Medium' ? 'band-medium' : 'band-low'; }
  override ngOnInit(): void { super.ngOnInit(); if (SHOW_RISK_FORECAST) this.loadForecast(); }
  override ngOnDestroy(): void { super.ngOnDestroy(); this.forecastSubscription?.unsubscribe(); }
  override applyFilters(filters: WorkforceFilters): void {
    super.applyFilters(filters);
    if (SHOW_RISK_FORECAST) this.loadForecast();
  }
  private loadForecast(): void {
    this.forecastSubscription?.unsubscribe();
    this.forecastLoading = true;
    this.forecastSubscription = this.forecastApi.get<{ riskForecast: ForecastRow[] }>('/workforce/department-risk-forecast', {
      groupBy: this.groupBy,
      employmentType: this.employmentType || undefined,
    }).subscribe({
      next: data => { this.forecast = data.riskForecast ?? []; this.forecastLoading = false; },
      error: () => { this.forecastError = 'Unable to load risk forecast.'; this.forecastLoading = false; },
    });
  }
}
